import * as React from 'react'
export const Nl = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.5 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 85.5h513v342H0z" />
    <path fill="#cd1f2a" d="M0 85.5h513v114H0z" />
    <path fill="#1d4185" d="M0 312h513v114H0z" />
  </svg>
)
